module.exports = __webpack_public_path__ + "img/cctlogo.eb2b22b3.png";